export const DEFAULT_MEDIA_PAGE_SIZE = 24;

export const MEDIA_PAGE_SIZE_OPTIONS = [24, 48, 96];
